<template>
  <div class="slider-wrap" v-if="show">
    <div class="slider" ref="slider">
      <div class="close-btn" @click="onClose">
        <img src="@/assets/images/captcha/icon_close_black.webp" />
      </div>
      <!-- 请完成安全验证后继续： -->
      <div class="title">{{ $t('login.captchaTitle') }}</div>
      <div class="content">
        <div class="refresh-btn" :class="{ refreshing }" @click="refreshCaptcha">
          <img src="@/assets/images/captcha/icon_refresh_icon.webp" />
        </div>
        <div class="bg-img-div">
          <img ref="bgImg" :src="bgImage" />
        </div>
        <div class="slider-img-div" ref="sliderImgDiv" id="slider-img-div" :style="{ width: tmpImgWidth }">
          <img ref="sliderImg" :src="tmpImage" :class="{ hidden: refreshing }" />
        </div>
      </div>
      <div class="handle">
        <div class="slider-move" v-if="status == 0">
          <!-- 按住左边按钮拖动完成上方拼图 -->
          <div class="slider-move-track" v-if="dragXOffset < 10">{{ $t('login.captchaTips') }}</div>
          <div ref="sliderMoveBtn" class="move-btn-wrap">
            <div
              class="btn-mask"
              @mousedown="dragStart($event)"
              @mousemove="dragMoving($event)"
              @mouseup="dragFinish($event)"
              @touchstart="dragStart($event)"
              @touchmove="dragMoving($event)"
              @touchend="dragFinish($event)"
            />
            <div class="move-btn" />
          </div>
        </div>
        <div class="success-status" v-if="status == 1">
          <img src="@/assets/images/captcha/success_tips_icon.webp" class="icon mr8" />
          <!-- 验证成功 -->
          <span>{{ $t('login.captchaVerifySuccess') }}</span>
        </div>
        <div class="failure-status" v-if="status == 2">
          <img src="@/assets/images/captcha/error_tips_icon.webp" class="icon mr8" />
          <!-- 验证失败，请重试 -->
          <span>{{ $t('login.captchaVerifyFail') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import { refreshData } from './mock'
  import { getCaptcha, verifyCaptcha } from '@/api/api.js'
  import { down, move, up, initConfig, clearAllPreventDefault } from './captcha'
  import { wbToast } from '@/utils/tips.js'
  import { genDeviceUuid } from '@/utils/user-verify-helper.js'

  export default {
    name: 'captcha-vertify',

    props: {
      show: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        refreshing: false,
        status: 0,
        originData: undefined,
        isPressDown: false,
        widthScalc: 1,
        dragXOffset: 0,
        tmpInitLeft: 0
      }
    },
    computed: {
      bgImage() {
        if (this.originData && this.originData.backgroundImage) {
          return this.originData.backgroundImage
        } else {
          return null
        }
      },

      tmpImage() {
        if (this.originData && this.originData.templateImage) {
          return this.originData.templateImage
        } else {
          return null
        }
      },

      tmpImgWidth() {
        if (this.originData) {
          const oWidth = this.originData.templateImageWidth
          const oHeight = this.originData.templateImageHeight
          const heightScalc = 140 / oHeight
          const w = oWidth * heightScalc
          // console.log('w', w)
          return w + 'px'
        } else {
          return 'auto'
        }
      }
    },

    watch: {
      show: {
        handler(val) {
          if (val) {
            this.refreshCaptcha()
            this.$nextTick(() => {
              clearAllPreventDefault(this.$refs.slider)
            })
          }
        },
        immediate: true
      }
    },

    created() {
      initConfig(257, 140, 68, 42, 189)
    },
    // mounted() {},
    methods: {
      async genCode() {
        const code = await genDeviceUuid()
        return `${code}_${this.type}`
      },

      onClose() {
        this.$emit('update:show', false)
      },

      initConfig,
      async refreshCaptcha() {
        this.status = 0
        this.refreshing = true
        try {
          this.reset() // 重置初始化数据
          const vCode = await this.genCode()
          const { data } = await getCaptcha(vCode)
          this.originData = data
          this.widthScalc = 257 / this.originData.backgroundImageWidth
          console.log('scalc:', this.widthScalc)
        } finally {
          this.initTmpLeft()
          this.refreshing = false
        }
      },

      // 初始化滑块左侧距离
      initTmpLeft() {
        setTimeout(() => {
          this.$nextTick(() => {
            let left = 68 - this.$refs.sliderImg.clientWidth
            if (left === 68) {
              left = 0
            }
            this.tmpInitLeft = left
            console.log('tmpInitLeft:', this.tmpInitLeft)
            this.$refs.sliderImgDiv.style.left = `${this.tmpInitLeft}px`
          })
        }, 10)
      },

      reset() {
        this.$nextTick(() => {
          this.dragXOffset = 0
          this.$refs.sliderMoveBtn.style.transform = `translate(0px, 0px)`
          this.$refs.sliderImgDiv.style.transform = `translate(0px, 0px)`
        })
      },
      // 按下
      doDown() {
        this.isPressDown = true
      },
      // 抬起
      doUp(config) {
        console.log(config)
        this.isPressDown = false
        const position = this.getPosition(config)
        this.doVerify({
          config: [position],
          verifySuccess: code => {
            this.status = 1
            setTimeout(() => {
              this.onClose()
              this.$emit('onPass', code)
            }, 100)
          },
          verifyFail: () => {
            this.status = 2
            setTimeout(() => {
              this.refreshCaptcha()
            }, 1000)
          },
          refreshHandle: msg => {
            // 验证码已过期，请重试
            wbToast(msg || this.$t('login.captchaOutTime'))
            this.refreshCaptcha()
          }
        })
      },
      // 移动
      doMove(config) {
        const moveX = config.moveX
        this.$refs.sliderMoveBtn.style.transform = 'translate(' + moveX + 'px, 0px)'
        this.$refs.sliderImgDiv.style.transform = 'translate(' + moveX + 'px, 0px)'
        this.dragXOffset = moveX
      },

      // 开始拖动
      dragStart(event) {
        down(event, this.doDown)
      },
      // 移动
      dragMoving(event) {
        if (!this.isPressDown) return // 没有按下事件不触发移动事件
        move(event, this.doMove)
      },
      // 结束拖动
      dragFinish(event) {
        up(event, this.doUp)
      },

      getPosition(config) {
        const moveX = config.moveX
        const offsetLeft = this.tmpInitLeft
        let x = (moveX + offsetLeft) / this.widthScalc
        x = parseInt(x)
        return { x, y: 0 }
      },

      async doVerify({ config, verifySuccess, verifyFail, refreshHandle }) {
        const vCode = await this.genCode()
        const params = {
          code: vCode,
          trackList: config
        }
        const { code, data, msg } = await verifyCaptcha(params)
        if (code === 0) {
          if (data) {
            if (verifySuccess) {
              verifySuccess(vCode)
            }
          } else {
            if (verifyFail) {
              verifyFail()
            }
          }
        } else if (code === 30001) {
          if (refreshHandle) {
            refreshHandle(msg)
          }
        } else {
          wbToast(msg)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .slider-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    z-index: 99999;
  }

  .title {
    font-size: 17px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    padding-bottom: 16px;
  }

  .slider {
    background-color: #fff;
    width: 289px;
    z-index: 999;
    padding: 20px 16px;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    user-select: none;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    > img {
      width: 16px;
      height: 16px;
    }
  }

  .slider .content {
    width: 100%;
    height: 140px;
    border-radius: 4px;
    position: relative;
    overflow: hidden;

    .refresh-btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 9;

      > img {
        width: 14px;
        height: 14px;
      }

      &.refreshing {
        > img {
          animation: changeright 1s linear infinite;
        }
      }
    }
  }

  .bg-img-div {
    width: 100%;
    height: 140px;
    position: absolute;
    transform: translate(0px, 0px);
    background-size: 100% 159px;
    background-image: none;
    background-position: 0 0;
    z-index: 0;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .slider-img-div {
    width: auto;
    height: 140px;
    position: absolute;
    transform: translate(0px, 0px);
    z-index: 1;

    > img {
      width: 100%;
      height: 100%;
      visibility: visible;
      &.hidden {
        visibility: hidden;
      }
    }
  }

  .handle {
    margin-top: 8px;
    height: 50px;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
  }

  .slider-move {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    position: relative;

    .slider-move-track {
      line-height: 50px;
      white-space: nowrap;
      color: #999;
      -moz-user-select: none;
      -webkit-user-select: none;
      user-select: none;
      height: 50px;
      font-size: 12px;
      text-align: right;
      padding-right: 12px;
    }

    .move-btn-wrap {
      width: 68px; // 包括左右边距
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      position: absolute;
      top: 0px;
      left: 0px;
      transform: translate(0px, 0px);

      .btn-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 11;
        background: transparent;
      }

      .move-btn {
        background-color: #fff;
        background-image: url('../../assets/images/captcha/icon_arrows_fullcore.webp');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 24px 24px;
        width: 60px;
        height: 42px;
        border-radius: 2px;
        box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.03);
      }
    }
  }

  .success-status,
  .failure-status {
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-radius: 4px;
    font-size: 13px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      width: 14px;
      height: 14px;
      margin-right: 8px;
      vertical-align: text-top;
    }
  }
  .success-status {
    background: rgba(0, 173, 60, 0.1);
    color: #00ad3c;
  }
  .failure-status {
    background: rgba(235, 85, 80, 0.1);
    color: #eb5550;
  }

  @keyframes changeright {
    0% {
      -webkit-transform: rotate(0deg);
    }

    50% {
      -webkit-transform: rotate(180deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }
</style>
